import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import UserActions from '@Actions/userActions';
import './style.scss';

import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Image from '@Uilib/h3Image';
import H3Text from '@Uilib/h3Text';

import { Drawer, Table } from 'antd';

import LabelGenerationActions from '@Actions/configurations/labelGenerationActions';
import GlobalLabelsList from '../GlobalLabelsList';
import LabelGenerationCard from '../LabelGenerationCard';
import LabelGenerationForm from '../LabelGenerationFrom';

const LabelGenerationList = ({
  user, entityName, tab, docTab, getLabelGenerationLoading, labelGeneration, getLabelGeneration, deleteLabelLoading, deleteLabel,
}) => {
  const [showUpdateLabelGeneration, setShowUpdateLabelGeneration] = useState(false);
  const [showLabelGenerationDrawer, setShowLabelGenerationDrawer] = useState(false);
  const [call, setCall] = useState(false);
  const [callCard, setCallCard] = useState(false);
  const [selectedLabelGeneration, setSelectedLabelGeneration] = useState({});
  const [showAddNew, setShowAddNew] = useState(false);

  useEffect(() => {
    if (entityName) {
      getLabelGeneration({ orgId: user?.org_id, entityName }, () => { });
    }
  }, [entityName, call]);

  const handelDeleteTemplate = (labelTemplateId, callback) => {
    deleteLabel({ label_template_id: labelTemplateId }, () => {
      callback();
      setCall(!call);
    });
  };

  const getColumns = () => {
    const columns = [
      {
        title: '',
        render: (record) => (
          <React.Fragment>
            <div
              onClick={(e) => {
                e.stopPropagation();
                // setShowLabelGenerationDrawer(true);
                // setSelectedLabelGeneration(record);
              }}
            >
              <LabelGenerationCard
                LabelGenerationItem={record}
                LabelGenerationId={record?.label_template_id}
                setSelectedLabelGeneration={(record) => setSelectedLabelGeneration(record)}
                setShowUpdateLabelGeneration={setShowUpdateLabelGeneration}
                cardTitle={record?.template_name}
                isLoading={deleteLabelLoading}
                handelDeleteTemplate={handelDeleteTemplate}
                callback={
                  () => {
                    setCallCard(!callCard);
                  }
                }
              />
            </div>
          </React.Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];

    return columns;
  };

  return (
    <Fragment>
      <div className="label_gen__wrapper">
        <div className="label_gen__inner__wrapper">
          <div className="label_gen__table__wrapper">
            <div className="generic-table-container label_gen__table">
              <Table
                title={() => (
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {`${labelGeneration?.length ?? 0} Template(s)`}
                    <Fragment>
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ New"
                        customClass="labels__header__add-button hide__in-mobile"
                        onClick={() => setShowAddNew(true)}
                      />
                    </Fragment>
                  </div>
                )}
                bordered
                showHeader={false}
                dataSource={labelGeneration || []}
                columns={getColumns()}
                size="small"
                pagination={false}
                loading={getLabelGenerationLoading}
              />
            </div>
          </div>
        </div>
      </div>

      <Drawer
        open={showLabelGenerationDrawer}
        width="925px"
        mask
        onClose={(e) => {
          e.stopPropagation();
          setShowLabelGenerationDrawer(false);
        }}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '875px' }}>
            <H3Text text={`Label Generation Template for - ${selectedLabelGeneration?.template_name}`} className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowLabelGenerationDrawer(false);
              }}
            />
          </div>
        </div>
        {/* <LabelGenerationForm
          selectedLabelGeneration={selectedLabelGeneration}
          callback={() => {
            setShowUpdateLabelGeneration(false);
            setCall(!call);
          }}
        /> */}
      </Drawer>

      <Drawer
        open={showUpdateLabelGeneration}
        width="600px"
        mask
        onClose={() => setShowUpdateLabelGeneration(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '550px' }}>
            <H3Text text="Update Label" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateLabelGeneration(false)} />
          </div>
        </div>
        <LabelGenerationForm
          selectedLabel={selectedLabelGeneration}
          selectedOrgLabels={labelGeneration}
          isUpdate
          callback={() => {
            setShowUpdateLabelGeneration(false);
            setCall(!call);
          }}
        />
      </Drawer>

      <Drawer
        open={showAddNew}
        width="800px"
        mask
        onClose={() => {
          setShowAddNew(false);
        }}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '750px' }}>
            <H3Text text="Add New Template" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowAddNew(false);
              }}
            />
          </div>
        </div>
        <div>
          <GlobalLabelsList entityName={entityName} />
        </div>
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, LabelGenerationReducers }) => ({
  user: UserReducers.user,
  getLabelGenerationLoading: LabelGenerationReducers.getLabelGenerationLoading,
  labelGeneration: LabelGenerationReducers.labelGeneration,
  deleteLabelLoading: LabelGenerationReducers.deleteLabelLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
  getLabelGeneration: (payload, callback) => dispatch(LabelGenerationActions.getLabelGeneration(payload, callback)),
  deleteLabel: (payload, callback) => dispatch(LabelGenerationActions.deleteLabel(payload, callback)),
});

LabelGenerationList.propTypes = {
  user: PropTypes.object,
  tab: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LabelGenerationList));
